import { render, staticRenderFns } from "./toMessageCenter.vue?vue&type=template&id=6f724b95&"
import script from "./toMessageCenter.vue?vue&type=script&lang=js&"
export * from "./toMessageCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports